import React from 'react'
import SelectBox from '../common/SelectBox'
import SelfEmployed from './IncomeTypes/SelfEmployed'
import PAYG from './IncomeTypes/PAYG'
import {
  getLoanApplicationUser,
  getSecondaryLoanApplicationUser,
  getMainIncome,
} from '../../../../reducers'
import { connect } from 'react-redux'
import {incomeChanged, incomeSourceChanged} from '../../../../actions'

class IncomeSourceCard extends React.Component {
  onInnerChange = (mainIncome) => {
    const { currentApplicant } = this.props;
    // Sync current income state in the child version
    this.props.incomeChanged({ ...mainIncome, currentApplicant })
  }

  render() {
    const {
      incomeSource,
      secondaryIncomeSource,
      incomeSourceChanged,
      mainIncome,
      errors,
      currentApplicant
    } = this.props
    const currentIncomeSource = currentApplicant === 'primary' ? incomeSource : secondaryIncomeSource

    return (
      <div className='card card-single'>
        <div className='card-body'>
          <div className='qn'>
            Main income source
          </div>
          <div className='smaller mb-1'>How do you earn your main source of income?</div>
          <div className='row no-gutters mb-2'>
            <div className='col-12 col-sm-6'>
              <SelectBox name={'income-source'}
                         checked={ currentIncomeSource === 'payg' }
                         value={'payg'}
                         text={'PAYG'}
                         currentApplicant={currentApplicant}
                         onChange={incomeSourceChanged}
              />
            </div>
            <div className='col-12 col-sm-6'>
              <SelectBox name={'income-source'}
                         checked={ currentIncomeSource === 'selfEmployed' }
                         value={'selfEmployed'}
                         text={'Self-employed'}
                         currentApplicant={currentApplicant}
                         onChange={incomeSourceChanged}
              />
            </div>
          </div>
          {(currentIncomeSource === 'payg') &&
            <PAYG income={ mainIncome }
                  errors={ errors }
                  showEmployerType={ true }
                  currentApplicant={currentApplicant}
                  onChange={ this.onInnerChange } />
          }
          {(currentIncomeSource === 'selfEmployed') &&
            <SelfEmployed income={ mainIncome }
                          errors={ errors }
                          onChange={ this.onInnerChange } />
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    incomeSource: getLoanApplicationUser(state).incomeSource,
    secondaryIncomeSource: getSecondaryLoanApplicationUser(state).incomeSource,
    mainIncome: getMainIncome(state),
  }
};

export default connect(mapStateToProps, {
  incomeSourceChanged,
  incomeChanged
}) (IncomeSourceCard)
